<template>
	<div class="search-box">
		<div class="search-form">

			<div class="form-item" :class="item.arrowType" v-for="item in goodsSearchFieldsSettingList">
				<div class="form-label">
					{{item.showName}}
				</div>

				<!-- 文本 -->
				<div v-if="item.fieldTypeName == 'text'" class="form-value">
					<el-input v-model="searchForm[item.selectedVal]" :maxlength="getInputMaxLength(item)" :placeholder='item.tipText'></el-input>
				</div>

				<!-- 数字 -->
				<div v-if="item.fieldTypeName == 'number'" class="form-value">
					<el-input class="value-item" :controls='false' :placeholder='item.tipText' :max='10**13-1' v-model="searchForm[item.selectedVal+'start']" @input='(value)=>{ return numberInputCheck(value,item,"start")}' @blur='()=>{ return inputChange(item,"start")}'></el-input>
					<div class='value-divider'>-</div>
					<el-input class="value-item" :controls='false' :placeholder='item.tipText' :max='10**13-1' v-model="searchForm[item.selectedVal+'end']" @input='()=>{ return numberInputCheck(item,"end")}' @blur='()=>{ return inputChange(item,"end")}'></el-input>
				</div>

				<!-- 时间 -->
				<div v-if="item.fieldTypeName == 'time'" class="form-value">
					<el-date-picker class="value-item" v-model="searchForm[item.selectedVal+'start']" type="date" value-format="yyyy-MM-dd" :placeholder="item.tipText" @change='()=>{ return dateChange(item,"start")}' @clear="()=>{ return dateClear(item,'start')}">
					</el-date-picker>
					<div class='value-divider'>-</div>
					<el-date-picker class="value-item" v-model="searchForm[item.selectedVal+'end']" type="date" value-format="yyyy-MM-dd" :placeholder="item.tipText" @change='()=>{ return dateChange(item,"end")}' @clear="()=>{ return dateClear(item,'end')}">
					</el-date-picker>
				</div>

				<!-- 下拉框 -->
				<div v-if="item.fieldTypeName == 'select'" class="form-value form-multiselect">
					<div class="multiselect-item" v-for="option in item.optionList" :class="{active: (searchForm[item.selectedVal] || []).includes(option.text)}" @click="optionItemClick(item,option)">
						{{option.text}}
					</div>
				</div>

				<div v-if="item.isShowArrow" class="form-op" @click="arrowClick(item)">
					{{item.arrowType == 'arrow_more' ? '更多' : '收起'}}
					<div class="op-arrow">
					</div>
				</div>
			</div>
		</div>

		<div class="search-btn">
			<el-button class="btn-item" type="primary" @click="confirmSearch()">确定 </el-button>
			<el-button class="btn-item" style='height: 42px;' @click="resetSearch()">清空</el-button>
		</div>

	</div>

</template>

<script>
	import { getParam } from '../../utils/api-utils/api-params.js'
	import goodsUtils from '../../utils/api-utils/api-goods.js'
	import commonUtlis from '../../utils/common-utlis.js';
	export default {
		name: 'GoodsFieldSearch',
		computed: {

		},
		props: {
			goodsFieldSearchForm: {
				type: Object,
				default: {}
			},
		},
		data() {
			return {
				searchForm: {}, // 表单值
				fieldTypeMap: {
					0: 'text',
					1: 'number',
					2: 'time',
					3: 'select',
				},
				goodsSearchFieldsSettingList: [],
				isLoaded: false,
				params: undefined,
				searchFormOld: {}, // 表单值对比数据
			}
		},
		created: async function() {
			// 获取参数
			await this.loadParam();

			// 设置表单数据
			this.setFormData();

			this.isLoaded = true
		},
		methods: {
			/**
			 * 加载参数
			 */
			async loadParam() {
				let params = await getParam("goodsSearchFieldsSettingList");

				let goodsSearchFieldsSettingList = JSON.parse(params.goodsSearchFieldsSettingList || '[]')
				this.$nextTick(() => {
					goodsSearchFieldsSettingList.forEach((item, index) => {
						this.$set(this.goodsSearchFieldsSettingList, this.goodsSearchFieldsSettingList.length, item);
					})
					console.log('DOM 已更新');
				});
			},

			/**
			 * 设置表单数据
			 */
			setFormData() {
				this.goodsSearchFieldsSettingList.forEach((item, index) => {
					// 补充索引
					item.index = index;

					// 转化后的类型
					item.fieldTypeName = this.fieldTypeMap[item.fieldType];

					// 表单提示文字
					let tip = ['time', 'select'].includes(item.fieldTypeName) ? '请选择' : '请输入';
					item.tipText = tip + item.showName;

					// 多选项展示 需要保证响应式
					this.$set(this.goodsSearchFieldsSettingList[index], 'arrowType', 'arrow_more');
					this.$set(this.goodsSearchFieldsSettingList[index], 'isShowArrow', this.judgeShouldWrap(item, 820, 15));

					// 最大输入长度
					item.maxLength = this.getInputMaxLength(item)

					// 多选项展示 上限20个
					item.optionList = (item.optionList || []).slice(0, 20);

					// 表单数据 保证数据响应
					if (['time', 'number'].includes(item.fieldTypeName)) {
						this.$set(this.searchForm, item.selectedVal, '');
						this.$set(this.searchForm, item.selectedVal + 'start', '');
						this.$set(this.searchForm, item.selectedVal + 'end', '');
					} else {
						this.$set(this.searchForm, item.selectedVal, '');
					}
				})

				if (!commonUtlis.isEmptyObjectV2(this.goodsFieldSearchForm)) {
					for (const [key, value] of Object.entries(this.goodsFieldSearchForm)) {
						this.$set(this.searchForm, key, value);
					}

				}

				// this.searchForm = commonUtlis.isEmptyObjectV2(this.goodsFieldSearchForm) ? this.searchForm : this.goodsFieldSearchForm;
			},

			/**
			 * 获取最大输入长度
			 */
			getInputMaxLength(inputData) {
				let lengthMap = {
					text: 255,
					number: 10,
				};

				return lengthMap[inputData.fieldTypeName] || 10;
			},

			/**
			 * 估算文本长度
			 */
			estimateTextWidth(text, fontSize) {
				let width = 0;
				for (let char of text) {
					if (/[a-zA-Z]/.test(char)) {
						width += fontSize * 0.6; // 英文字母
					} else if (/[0-9]/.test(char)) {
						width += fontSize * 0.6; // 数字
					} else if (/[\u4e00-\u9fa5]/.test(char)) {
						width += fontSize; // 中文字符
					} else {
						width += fontSize * 0.3; // 其他符号
					}
				}
				return width;
			},

			/**
			 * 判断是否需要换行
			 */
			judgeShouldWrap(formItemInfo, containerWidth, fontSize) {
				if (formItemInfo.fieldTypeName != 'select') {
					return false
				}

				let optionTexts = formItemInfo.optionList.map(item => (item.text || '').slice(0, 10)).join('')
				const estimatedWidth = this.estimateTextWidth(optionTexts, fontSize) + formItemInfo.optionList.length * 30; // margin-right 30
				return estimatedWidth > containerWidth;
			},

			/**
			 * 箭头点击
			 */
			arrowClick(formItemInfo) {
				this.$nextTick(() => {
					formItemInfo.arrowType = formItemInfo.arrowType == 'arrow_more' ? 'arrow_less' : 'arrow_more';
					this.goodsSearchFieldsSettingList[formItemInfo.index].arrowType = formItemInfo.arrowType;
					console.log(this.goodsSearchFieldsSettingList[formItemInfo.index].arrowType)
				});
			},


			/**
			 * 确认搜索
			 */
			async resetSearch() {
				for (const [key, value] of Object.entries(this.searchForm)) {
					this.$set(this.searchForm, key, '');
				}
			},

			/**
			 * 确认搜索
			 */
			async confirmSearch() {
				// 表单校验
				if (!this.formSubmitCheck()) {
					return
				}

				// 获取查询参数
				let searchCfg = this.getSearchCfg();

				// 调erp接口获取 goodsid
				// let goodsIdOfSearch = await goodsUtils.getGoodsIdByGoodsField(searchCfg)

				this.$emit('confirmGoodsFieldSearch', {
					customFieldFilter:searchCfg,
					goodsFieldSearchForm: this.searchForm,
				})

			},

			/**
			 * 表单校验
			 */
			formSubmitCheck() {
				// 必填 但是 未填写的表单项
				let searchCfgList = this.goodsSearchFieldsSettingList.filter(item => !!this.searchForm[item.selectedVal]);

				if (searchCfgList.length > 0) {
					return true
				}

				// 提示并返回校验不通过
				// toast('请填写筛选条件')
				this.$emit('confirmGoodsFieldSearch', {
					goodsIdList: [],
					goodsFieldSearchForm: {},
				})

				return false
			},

			/**
			 * 获取查询参数
			 */
			getSearchCfg() {
				let searchCfg = {};
				this.goodsSearchFieldsSettingList.forEach(item => {
					let tempValue = this.searchForm[item.selectedVal];

					// 多选项 值的格式需要转为字符串
					if (['select'].includes(item.fieldTypeName)) {
						tempValue = !!tempValue ? '$in$' + tempValue.join(',') : ''
					}
					// 范围条件 格式处理
					else if (['time', 'number'].includes(item.fieldTypeName)) {
						tempValue = this.getRangeValueOfField(tempValue, item.fieldTypeName)
					}
					// 文本条件 格式处理
					else {
						tempValue = !!tempValue ? '$eq$' + tempValue : ''
					}

					// 赋值
					searchCfg[item.selectedVal] = tempValue;
				})

				return searchCfg;
			},

			/**
			 * 获取范围条件的值
			 */
			getRangeValueOfField(fieldValue = '', fieldTypeName) {
				fieldValue = fieldValue.split(',');

				// 获取并校验起始值
				let startValue = fieldValue && fieldValue[0] || '';
				let endValue = fieldValue && fieldValue[1] || '';

				// 时间参数 需要 拼接时分秒
				if (fieldTypeName == 'time') {
					startValue = startValue ? startValue + ' 00:00:00' : '';
					endValue = endValue ? endValue + ' 23:59:59' : '';
				}

				if (!!startValue && !!endValue) {
					return `$gtlt$${startValue},${endValue}`
				}

				if (!!startValue) {
					return `$gteq$${startValue}`
				}

				if (!!endValue) {
					return `$lteq$${endValue}`
				}

				return ''
			},


			/**
			 * 输入框input
			 */
			numberInputCheck(value = '', formItemInfo, rangeType) {

				// 当前表单选项 相关信息
				let itemInfo = formItemInfo;

				// 历史输入值
				let oldValue = this.searchFormOld[itemInfo.selectedVal + rangeType] || "";

				let reg = /^-?(0|([1-9][0-9]*){0,13})(\.|\.[\d]{1,4})?$/;

				let temp = (value && !reg.test(value)) ? oldValue : (Number(value) || 0) < (10 ** 13 - 1) ? value : oldValue;

				// 更新数据
				this.searchForm[itemInfo.selectedVal + rangeType] = temp
				// this.$set(this.searchForm, itemInfo.selectedVal + rangeType, temp);

				//	记录对比值
				this.searchFormOld[itemInfo.selectedVal + rangeType] = temp;
			},


			/**
			 * 输入框失焦
			 */
			inputChange(formItemInfo, rangeType) {
				// 当前表单选项 相关信息
				let itemInfo = formItemInfo;

				let value = this.searchForm[itemInfo.selectedVal + rangeType] || ""

				// 获取起始值
				let startValue = this.searchForm[itemInfo.selectedVal + 'start'] || '';
				let endValue = this.searchForm[itemInfo.selectedVal + 'end'] || '';
				let errMsg = '';

				// 校验起始值
				if (rangeType == 'end' && !!startValue && !!value && Number(value) <= Number(startValue)) {
					errMsg = '起始值需要小于结束值';
				}
				if (rangeType == 'start' && !!endValue && !!value && Number(value) >= Number(endValue)) {
					errMsg = '结束值需要大于起始值';
				}
				if (!!errMsg) {
					this.$message.error(errMsg);
					this.searchForm[itemInfo.selectedVal + rangeType] = ''
					return
				}
				// 更新数据
				startValue = rangeType == 'start' ? value : startValue;
				endValue = rangeType == 'end' ? value : endValue;

				this.searchForm[itemInfo.selectedVal] = `${startValue}${!!startValue || !!endValue && ',' ||''}${endValue}`;
				this.searchForm[itemInfo.selectedVal + rangeType] = value;
			},

			/**
			 * 日期选择框清空
			 */
			dateClear(itemInfo, rangeType) {
				// 获取起始值
				let startValue = this.searchForm[itemInfo.selectedVal + 'start'] || '';
				let endValue = this.searchForm[itemInfo.selectedVal + 'end'] || '';

				// 重置数据
				startValue = rangeType == 'start' ? '' : startValue;
				endValue = rangeType == 'end' ? '' : endValue;

				this.searchForm[itemInfo.selectedVal] = `${startValue}${!!startValue || !!endValue && ',' ||''}${endValue}`;
				this.searchForm[itemInfo.selectedVal + rangeType] = value;
			},

			/**
			 * 日期选择框失焦
			 */
			dateChange(formItemInfo, rangeType) {
				// 当前表单选项 相关信息
				let itemInfo = formItemInfo;

				let value = this.searchForm[itemInfo.selectedVal + rangeType] || ""

				// 获取起始值
				let startValue = this.searchForm[itemInfo.selectedVal + 'start'] || '';
				let endValue = this.searchForm[itemInfo.selectedVal + 'end'] || '';
				let errMsg = '';

				// 校验起始值 
				if (rangeType == 'end' && !!startValue && !!value && value < startValue) {
					errMsg = '起始日期需要小于结束日期'
				}
				if (rangeType == 'start' && !!endValue && !!value && value > endValue) {
					errMsg = '结束日期需要大于起始日期'
				}
				if (!!errMsg) {
					this.$message.error(errMsg);
					this.searchForm[itemInfo.selectedVal + rangeType] = ''
					return
				}

				// 更新数据
				startValue = rangeType == 'start' ? value : startValue;
				endValue = rangeType == 'end' ? value : endValue;

				this.searchForm[itemInfo.selectedVal] = `${startValue}${!!startValue && !!endValue && ',' ||''}${endValue}`;
				this.searchForm[itemInfo.selectedVal + rangeType] = value;
			},

			/**
			 * 多选项点击
			 */
			optionItemClick(itemInfo, optionItemInfo) {
				// // 当前表单选项 相关信息
				// let itemInfo = e.currentTarget.dataset.iteminfo;
				// let optionItemInfo = e.currentTarget.dataset.optioniteminfo;

				// 已选数据
				let searchFormItem = this.searchForm[itemInfo.selectedVal] || [];

				// 判断是否存在
				let isChosed = searchFormItem.includes(optionItemInfo.text)

				// 设置输入框的值
				searchFormItem = isChosed ? searchFormItem.filter(item => item != optionItemInfo.text) : searchFormItem.concat([optionItemInfo.text])

				this.searchForm[itemInfo.selectedVal] = searchFormItem;
			},

		},
	}
</script>

<style scoped>
	.search-box {
		background-color: #fff;
		border-bottom-left-radius: 4px;
		border-bottom-right-radius: 4px;
		padding: 20px;
		border: 1px solid #F2F2F2;
	}

	.search-form {
		max-height: 600px;
		overflow: auto;
	}

	.form-item {
		display: flex;
		min-height: 40px;
		margin-bottom: 10px;
		align-items: center;
	}

	.form-label {
		width: 220px;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 14px;
		font-weight: 500;
	}

	.form-value {
		width: 450px;
		display: flex;
		align-items: center;
	}

	.value-item {
		width: 100%;
	}

	.value-divider {
		color: #DDDDDD;
		margin: 0 10px;
		width: 5px;
		line-height: 50px;
	}

	.search-btn {
		margin: 0 auto;
		text-align: center;
		padding-top: 20px;
	}

	.form-multiselect {
		width: 820px;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}

	.multiselect-item {
		margin-right: 30px;
		max-width: 150px;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		line-height: 30px;
		font-size: 15px;
		flex-shrink: 0;
		cursor: pointer;
	}

	.btn-item {
		margin: 0 30px;
	}

	.form-op {
		display: flex;
		cursor: pointer;
		margin-left: 50px;
	}

	.op-arrow {
		transition: all 0.5s ease;
	}

	.arrow_more .op-arrow {
		height: 7px;
		width: 7px;
		border-left: 1px solid #000;
		border-bottom: 1px solid #000;
		border-color: #aaa;
		transform: translate(7px, 7px) rotate(-45deg);
	}

	.arrow_less .op-arrow {
		height: 7px;
		width: 7px;
		border-left: 1px solid #000;
		border-bottom: 1px solid #000;
		border-color: #aaa;
		transform: translate(7px, 10px) rotate(135deg);
	}

	.arrow_more .form-multiselect {
		flex-wrap: nowrap;
		overflow: hidden;
	}

	.form-multiselect .active {
		color: #F56C6C;
	}

	/deep/ .el-date-editor.el-input,
	.el-date-editor.el-input__inner {
		width: 100% !important;
	}
</style>